// extracted by mini-css-extract-plugin
module.exports = {"cursor-pointer":"product-detail-description_cursor-pointer__a_yjf"};